module.exports = __webpack_public_path__ + "media/images/vector-21@2x-2e3964a5dc73734a21d2b9d9e1d34365.png";